import { render, staticRenderFns } from "./EntregaProductosTransportes.vue?vue&type=template&id=cf296ab0&"
import script from "./EntregaProductosTransportes.vue?vue&type=script&lang=js&"
export * from "./EntregaProductosTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports